/**
 * AboutHero.tsx — Gold Garage Door / About Us · Section 1/10
 * Navy hero · real team photo · 4-stat credibility strip
 * MOBILE: real <style> media queries (inline grid can't be overridden by Tailwind).
 *
 * IMAGE: upload IMG_7240.JPG -> https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/about-hero-team-sydney.webp (1920x1080, WebP q82)
 * 10WEB AI: keep <img> + <style>. Wave dividers intentional — do NOT strip.
 */

const HERO_IMG = "/wp-content/uploads/2026/06/about-hero-team-sydney.webp";
const NAVY = "#081438";
const GOLD = "#F5A623";
export default function AboutHero() {
  const stats = [{
    val: "2009",
    label: "Founded"
  }, {
    val: "217+",
    label: "Suburbs"
  }, {
    val: "1,247+",
    label: "Doors done"
  }, {
    val: "5.0★",
    label: "Google rating"
  }];
  return <section id="about-hero" style={{
    background: `radial-gradient(ellipse at 70% 0%, #1a2f5e 0%, ${NAVY} 60%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "6rem",
    paddingBottom: "5rem"
  }}>
      <style>{`
        .ah-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center; }
        .ah-stats { display: grid; grid-template-columns: repeat(4, 1fr); }
        @media (max-width: 880px) {
          .ah-grid { grid-template-columns: 1fr; gap: 2.5rem; }
          .ah-photo { order: -1; }
          #about-hero { padding-top: 4.5rem; }
        }
        @media (max-width: 880px) {
          .ah-photo img { height: auto !important; aspect-ratio: 4 / 3; object-position: center 30% !important; }
        }
        @media (max-width: 520px) {
          .ah-stats { grid-template-columns: repeat(2, 1fr); row-gap: 1.25rem; }
          .ah-stats > div { border-right: none !important; padding-left: 0 !important; }
          .ah-photo img { aspect-ratio: 1 / 1; }
        }
      `}</style>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}>
        <filter id="grain-ah"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#grain-ah)" />
      </svg>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      right: "-2rem",
      bottom: "-3rem",
      fontSize: "18rem",
      fontWeight: 900,
      color: `${GOLD}0D`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>GG</div>

      <div className="ah-grid" style={{
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        {/* LEFT — copy */}
        <div>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          background: `${GOLD}18`,
          border: `1px solid ${GOLD}40`,
          borderRadius: "9999px",
          padding: "0.375rem 1rem",
          marginBottom: "1.5rem"
        }}>
            <span style={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            background: GOLD,
            display: "inline-block"
          }} />
            <span style={{
            color: GOLD,
            fontSize: "0.7rem",
            fontWeight: 700,
            letterSpacing: "0.12em",
            fontFamily: "'Manrope', sans-serif"
          }}>FAMILY-RUN · BASS HILL NSW · SINCE 2009</span>
          </div>

          <h1 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.9rem, 7vw, 3.25rem)",
          lineHeight: 1.1,
          color: "#FFFFFF",
          marginBottom: "1.25rem"
        }}>
            Not a franchise.<br />Not a call centre.<br /><span style={{
            color: GOLD
          }}>Just Sydney's crew.</span>
          </h1>

          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.05rem",
          color: "rgba(255,255,255,0.78)",
          lineHeight: 1.7,
          marginBottom: "2rem",
          maxWidth: "480px"
        }}>
            Gold Garage Door has been fixing, installing and maintaining garage
            doors across Sydney since 2009. Same family. Same phone number. Same
            van turning up on time.
          </p>

          <div style={{
          display: "flex",
          gap: "1rem",
          flexWrap: "wrap"
        }}>
            <a href="tel:0485000933" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.875rem 1.75rem",
            background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
            color: NAVY,
            fontWeight: 700,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "0.95rem",
            boxShadow: `0 4px 20px ${GOLD}35`
          }}> 0485 000 933</a>
            <a href="#contact-us" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.875rem 1.75rem",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.25)",
            color: "#FFFFFF",
            fontWeight: 600,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "0.95rem"
          }}>Get a Free Quote</a>
          </div>

          <div className="ah-stats" style={{
          marginTop: "2.5rem",
          borderTop: "1px solid rgba(255,255,255,0.1)",
          paddingTop: "1.5rem"
        }}>
            {stats.map((s, i) => <div key={i} style={{
            paddingRight: "1rem",
            borderRight: i < 3 ? "1px solid rgba(255,255,255,0.1)" : "none",
            paddingLeft: i > 0 ? "1rem" : 0
          }}>
                <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: "1.5rem",
              color: GOLD,
              lineHeight: 1
            }}>{s.val}</div>
                <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.72rem",
              color: "rgba(255,255,255,0.5)",
              marginTop: "0.25rem",
              textTransform: "uppercase",
              letterSpacing: "0.08em"
            }}>{s.label}</div>
              </div>)}
          </div>
        </div>

        {/* RIGHT — photo */}
        <div className="ah-photo" style={{
        position: "relative"
      }}>
          <div aria-hidden style={{
          position: "absolute",
          top: "-12px",
          right: "-12px",
          width: "100%",
          height: "100%",
          border: `2px solid ${GOLD}30`,
          borderRadius: "16px",
          pointerEvents: "none"
        }} />
          <img src={HERO_IMG} alt="Gold Garage Door team delivering and installing a new roller door in Sydney" width={600} height={750} loading="eager" decoding="async" style={{
          width: "100%",
          height: "520px",
          objectFit: "cover",
          objectPosition: "center top",
          borderRadius: "12px",
          display: "block",
          position: "relative",
          zIndex: 1
        }} src="https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_7240-scaled.webp" />
          <div style={{
          position: "absolute",
          bottom: "1.25rem",
          left: "1.25rem",
          background: NAVY,
          border: `1px solid ${GOLD}40`,
          borderRadius: "999px",
          padding: "0.5rem 1.1rem",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          zIndex: 2,
          boxShadow: "0 4px 20px rgba(0,0,0,0.4)"
        }}>
            <span style={{
            fontSize: "1rem"
          }}></span>
            <span style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.8rem",
            fontWeight: 700,
            color: GOLD
          }}>5.0★ Google · 15+ years</span>
          </div>
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}